import React, { FunctionComponent, useCallback, useRef } from "react";

export interface DojoCreateWidgetProps {
	/** CSS class to apply */
	className?: string;
	widgetClassParams?: Record<string, any>;
	/** Widget declaration to be created, placed and started up */
	widgetClass: dojo._base.DeclareConstructor<dijit._WidgetBase>;
}

async function createComponent(props: DojoCreateWidgetProps) {
	return new props.widgetClass(props.widgetClassParams);
}


export const DojoCreateWidget: FunctionComponent<DojoCreateWidgetProps> = (props) => {
	const {
		widgetClass,
		className,
	} = props;
	const componentRef = useRef<any | null>();
	const contentRef = useCallback(async (domNode) => {
		if (domNode) {
			const component = await createComponent(props);

			if (component) {
				component.placeAt(domNode);
				component.startup();
			}
		} else if (componentRef.current) {
			componentRef.current.destroyRecursive();
			componentRef.current = null;
		}
	}, [widgetClass]);

	return <div className={className} ref={contentRef} />;
};

export default DojoCreateWidget;